/* eslint-disable no-unused-vars */
//format date into string but gives one day prior
const formatDateIntoString1 = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    weekday: "long", // Full name of the day (e.g., Saturday)
    year: "numeric", // Four-digit year (e.g., 2024)
    month: "long", // Full month name (e.g., June)
    day: "numeric", // Day of the month (e.g., 15)
  });
};
//format date into string with UTC timezone
const formatDateIntoString = (dateString) => {
  // Parse the date string as "YYYY-MM-DD" and explicitly set it to a UTC date
  const dateParts = dateString.split("-");
  const date = new Date(
    Date.UTC(
      parseInt(dateParts[0]), // Year
      parseInt(dateParts[1]) - 1, // Month (zero-based)
      parseInt(dateParts[2]) // Day
    )
  );

  return date.toLocaleDateString("en-US", {
    weekday: "long", // Full name of the day (e.g., Saturday)
    year: "numeric", // Four-digit year (e.g., 2024)
    month: "long", // Full month name (e.g., June)
    day: "numeric", // Day of the month (e.g., 15)
    timeZone: "UTC", // Forces output in UTC timezone
  });
};
const convertTo12HourFormat = (time24) => {
  let [hours, minutes] = time24.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format, with 12 for midnight/noon
  return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

function getDatesBetween(startDate, endDate) {
  if (!startDate || !endDate) return [];
  const dateArray = [];
  let currentDate = new Date(startDate);
  // Loop until the current date exceeds the end date
  while (currentDate <= new Date(endDate)) {
    // Format the date as "YYYY-MM-DD"
    dateArray.push(currentDate.toISOString().split("T")[0]);
    // Increment to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateArray;
}

function formatEventDateRange(loadInDate, loadInTime = "00:00", loadOutDate, loadOutTime = "23:59") {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Parse the input dates (use default time if none provided)
  const loadIn = new Date(`${loadInDate}T${loadInTime}`);
  const loadOut = new Date(`${loadOutDate}T${loadOutTime}`);

  // Helper function to get the ordinal suffix (e.g., "1st", "2nd", "3rd")
  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  // Format the date range
  const startMonth = months[loadIn.getMonth()];
  const startDay = loadIn.getDate();
  const startYear = loadIn.getFullYear();

  const endMonth = months[loadOut.getMonth()];
  const endDay = loadOut.getDate();
  const endYear = loadOut.getFullYear();

  // Check if times are included for formatting
  const startTime = (loadInTime !== "00:00") ? `, ${loadInTime}` : "";
  const endTime = (loadOutTime !== "23:59") ? `, ${loadOutTime}` : "";

  // Determine the format based on the range
  if (startYear === endYear && startMonth === endMonth) {
    // Same month and year
    return `${startMonth} ${startDay}${getOrdinal(startDay)}${startTime} - ${endDay}${getOrdinal(endDay)}${endTime} ${startYear}`;
  } else if (startYear === endYear) {
    // Same year, different months
    return `${startMonth} ${startDay}${getOrdinal(startDay)}${startTime} - ${endMonth} ${endDay}${getOrdinal(endDay)}${endTime} ${startYear}`;
  } else {
    // Different years
    return `${startMonth} ${startDay}${getOrdinal(startDay)}${startTime} ${startYear} - ${endMonth} ${endDay}${getOrdinal(endDay)}${endTime} ${endYear}`;
  }
}
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export { formatDateIntoString, convertTo12HourFormat, getDatesBetween, formatEventDateRange, getTodayDate };
